import React from "react";
import { BrowserRouter as Router, Link, Route, Switch } from "react-router-dom";

import routes from "./routes";
import withTracker from "./withTracker";
import "../src/assets/apm-tool.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./shards-dashboard/styles/shards-dashboards.1.1.0.min.css";
import LoginScreen from "./views/LoginScreen";
import PrivateRoute from "./privateRoute";
import ManagementView from "./views/mangementGame/ManagementGameView";
import ManagementGameDetails from "./views/mangementGame/ManagementGameDetailView";

export default () => (
  <Router basename={process.env.REACT_APP_BASENAME || ""}>
    <Switch>
    
    <div>
    <Link to="/management-game?id=:id"/>
    <Route exact path="/management-game" component={ManagementView}/>
    <Route exact path="/management-game/details" component={ManagementGameDetails}/>
    <Route exact path="/login" component={LoginScreen}/>
      {routes.map((route, index) => {
        return (
          <PrivateRoute
            key={index}
            path={route.path}
            exact={route.exact}
            component={withTracker(props => {
              return (
                <route.layout {...props}>
                  <route.component {...props} />
                </route.layout>
              );
            })}
          />
        );
      })}
    </div>
    </Switch>
  </Router>
);
